import { render, staticRenderFns } from "./StatisticsMainPage.vue?vue&type=template&id=90153e06&scoped=true"
import script from "./StatisticsMainPage.vue?vue&type=script&lang=js"
export * from "./StatisticsMainPage.vue?vue&type=script&lang=js"
import style0 from "./StatisticsMainPage.vue?vue&type=style&index=0&id=90153e06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90153e06",
  null
  
)

export default component.exports